export default {
    SINGLE: '@_get_single_student_discount',
    CLEAR_DISCOUNTS: '@_clear_discounts',
};
